import { useContext, useState, useEffect, useCallback } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function SymbolQty({ symbol_id }) {
  const socket = useContext(SocketContext);

  const [high, setHigh] = useState("-");
  const [low, setLow] = useState("-");
  const [ltp, setLtp] = useState("-");

  // ✅ Handle socket trade update
  const socketTrade = useCallback((msg) => {
    if (!msg) return;

    console.log("SOCKET DATA :", msg); // debug

    setHigh(msg.High ?? msg.high ?? "-");
    setLow(msg.Low ?? msg.low ?? "-");
    setLtp(msg.LTP ?? msg.ltp ?? "-");

  }, []);

  // ✅ Setup socket listener
  useEffect(() => {
    if (!socket || !symbol_id) return;

    const eventName = "trade" + symbol_id;

    socket.emit("giverate", symbol_id);
    socket.on(eventName, socketTrade);

    return () => {
      socket.off(eventName, socketTrade);
    };
  }, [socket, symbol_id, socketTrade]);

  return (

    <div
      className={`grid grid-cols-3 text-xs font-semibold text-[var(--text)] px-4 py-2 border-b border-t border-[var(--hover)]`}
    >
      <div className="flex flex-col items-center">
        <span className="text-[11px] text-[var(--text)]">HIGH</span>
        <span className="font-semibold">{high}</span>
      </div>

      <div className="flex flex-col items-center">
        <span className="text-[11px] text-[var(--text)]">LTP</span>
        <span className="font-semibold">{ltp}</span>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-[11px] text-[var(--text)]">LOW</span>
        <span className="font-semibold">{low}</span>
      </div>
    </div>
  );
}